<template>
  <div class="countdown-container" :style="finalCountSetting.finalMainStyle">
    <div v-if="timeData" class="countdown-box" :style="countdownBoxStyle">
      <div class="count-item-box" v-for="(item, index) in displayCountDownUnits" :key="index">
        <div class="count-item" :style="countItemStyle">
          <span class="count-item-number" :style="numberStyle">
            <!-- {{ timeData[item.value] }} -->
            <font-set
              :content="timeData[item.value]"
              :options="numberConfig.numberText || {}"
              v-if="numberConfig.numberText"
            ></font-set>
          </span>
          <span class="count-item-unit" :style="countUnitStyle" v-if="unitConfig.showUnit">
            <!-- {{ item.label }} -->
            <font-set
              :content="item.alias || item.label"
              :options="unitConfig.unitText || {}"
              v-if="unitConfig.unitText"
            ></font-set>
          </span>
        </div>
        <div class="divider" v-if="index < displayCountDownUnits.length - 1 && showDivide" :style="divideStyle">
          <icon-set :icon="divideIconOptions" v-if="divideType === 'custom'"></icon-set>
          <span class="line-divide" v-else :style="lineDivideStyle"></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { remCheck } from "utils"
import RAFCountdown from "./countdown"
import iconSet from "./icon-set.vue"
import fontSet from "./font-set.vue"
import { getFinalConfigAndStyles } from "materials/navMenu/render/customSubMenus/setting/getFinalConfigAndStyles"
import { props as mainProps } from "../toolbars/configs/mainConfig/props"
import { props as numberProps } from "../toolbars/configs/numberConfig/props"
import { props as unitProps } from "../toolbars/configs/unitConfig/props"
import dayjs from "dayjs"
export default {
  name: "cxCountdown",
  components: {
    iconSet,
    fontSet
  },
  mixins: [],
  props: {
    options: {
      default: () => {},
      type: Object
    },
    myid: {
      type: Object,
      default: null
    }
  },
  computed: {
    countdownBoxStyle() {
      return {
        ...this.mainMarginStyle,
        justifyContent: this?.finalCountSetting?.mainConfig.mainCheckbox?.checkBoxValue?.length > 1 ? "space-between" : "center"
      }
    },
    // 间距样式
    mainMarginStyle() {
      if (this.options.widthType === "px" && this.options.heightType === "px") {
        return {
          gap: "auto"
        }
      }
      if (this.options.widthType === "自动" && this.options.heightType === "自动") {
        return {
          gap: remCheck(this?.options?.mainConfig?.mainMargin ?? 8)
        }
      }
      return {}
    },
    filterUnits() {
      return this.displayCountDownUnits.map(item => item.value)
    },
    units() {
      return [
        { label: "年", value: "years", alias: this.unitConfig.yearAlias },
        { label: "月", value: "months", alias: this.unitConfig.monthAlias },
        { label: "天", value: "days", alias: this.unitConfig.dayAlias },
        { label: "时", value: "hours", alias: this.unitConfig.hourAlias },
        { label: "分", value: "minutes", alias: this.unitConfig.minuteAlias },
        { label: "秒", value: "seconds", alias: this.unitConfig.secondAlias }
      ]
    },
    finalCountSetting() {
      const { mainConfig = {}, numberConfig = {}, unitConfig } = this.options
      const [finalMainConfig, finalMainStyle] = getFinalConfigAndStyles(mainProps, mainConfig)
      const [finalUnitConfig, finalUnitStyle] = getFinalConfigAndStyles(unitProps, unitConfig)
      const [finalNumberConfig, finalNumberStyle] = getFinalConfigAndStyles(numberProps, numberConfig)
      return {
        mainConfig: finalMainConfig,
        numberConfig: finalNumberConfig,
        unitConfig: finalUnitConfig,
        finalMainStyle: {
          ...finalMainStyle,
        },
        finalUnitStyle,
        finalNumberStyle
      }
    },
    mainConfig() {
      return this.finalCountSetting?.mainConfig
    },
    numberConfig() {
      return this.finalCountSetting?.numberConfig
    },
    unitConfig() {
      return this.finalCountSetting?.unitConfig
    },
    countItemStyle() {
      const unitPosition = this.unitConfig.unitPosition
      if (["top", "bottom"].includes(unitPosition)) {
        return {
          gap: this.unitConfig.unitMargin,
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center"
        }
      } else {
        return {
          gap: this.unitConfig.unitMargin,
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center"
        }
      }
    },
    showDivide() {
      return this.mainConfig?.mainDivide?.showDivide
    },
    divideType() {
      return this.mainConfig?.mainDivide?.divideType
    },
    mainDivideConfig() {
      return this.mainConfig?.mainDivide
    },
    divideStyle() {
      return {
        transform: `translate(${remCheck(parseFloat(this.mainConfig?.mainMargin) / 2)}, 0)`
      }
    },
    lineDivideStyle() {
      return {
        display: "block",
        width: remCheck(this.mainDivideConfig?.divideWidth),
        height: remCheck(this.mainDivideConfig?.divideHeight),
        backgroundColor: this.$parseColor(this.mainDivideConfig?.divideIconColor)
      }
    },
    divideIconOptions() {
      return {
        iconSrc: this.mainConfig?.mainDivide?.divideIconSrc,
        iconType: this.mainConfig?.mainDivide?.divideIconType,
        iconWidth: this.mainConfig?.mainDivide?.divideWidth,
        iconHeight: this.mainConfig?.mainDivide?.divideHeight,
        iconMargin: 0,
        iconColor: this.$parseColor(this.mainConfig?.mainDivide?.divideIconColor,{isThemeColor:this.mainConfig?.mainDivide?.divideIconColorIsThemeColor }),
        iconPosition: "left",
        resInfo: this.mainConfig?.mainDivide?.divideResInfo
      }
    },
    countUnitStyle() {
      return {
        ...this.finalCountSetting.finalUnitStyle,
        ...(["top", "bottom"].includes(this.unitConfig.unitPosition)
          ? {
              transform: `translate(${this.unitConfig.unitOffset}, 0)`
            }
          : {
              transform: `translate(0, ${this.unitConfig.unitOffset})`
            })
      }
    },
    numberStyle() {
      const unitPosition = this.unitConfig.unitPosition
      if (["right", "bottom"].includes(unitPosition)) {
        return {
          order: 0,
          ...this.finalCountSetting.finalNumberStyle
        }
      } else {
        return {
          order: 1,
          ...this.finalCountSetting.finalNumberStyle
        }
      }
    },
    displayCountDownUnits() {
      return this.units.filter(unit => {
        return this?.mainConfig?.mainCheckbox?.checkBoxValue?.includes(unit.label)
      })
    },
    endTime() {
      return this.options.endTime
    },
    noCacheComponent() {
      return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
    },
    mainEnd() {
      return this.mainConfig?.mainEnd?.value ?? "stop"
    }
  },
  data() {
    return {
      timeData: null,
      hoverIndex: -1,
      activeIndex: -1
    }
  },
  watch: {
    mainEnd() {
      this.countdown?.stop()
      this.startCountDown(this.endTime)
    },
    endTime(newVal) {
      this.countdown?.stop()
      newVal && this.startCountDown(new Date(newVal).getTime())
    },
    displayCountDownUnits() {
      this.countdown?.stop()
      this.startCountDown(this.endTime)
    },
    "options.detailFieldMapping": {
      deep: true,
      handler(n, o) {
        if (n && this.noCacheComponent) {
          this.updateData()
        }
      }
    }
  },
  mounted() {
    if (this?.endTime) {
      this.startCountDown(this?.endTime)
    } else {
      this.clearCountDown()
    }
    let appId = this.options.appId || this.oldAppId
    if (
      this.noCacheComponent &&
      ((!this.options?.filedMapping?.flag && appId) || this.options?.detailFieldMapping?.isChecked)
    ) {
      this.updateData()
      if (this.isBigScreenPreview() && this.options.autoUpdate !== false) {
        this.reloadTimer = setInterval(() => this.updateData(), this.updateTimer)
      }
    }
  },
  methods: {
    async updateData() {
      this.updateNormalRect.call(
        this,
        data => {
          let hasData = false
          if (data && typeof data === "string") {
            this.$changeOptionsEV(data, "endTime", false, null, this.myid)
            hasData = true
          } else {
            // 如果首页绑定了字段匹配 不能获取第一个值
            if (
              !this.options.currentFiledMapping ||
              (this.options.currentFiledMapping && !this.options.currentFiledMapping.isChecked)
            ) {
              /*大屏外接数据空数据展示位暂无数据*/
              if (data.length === 0) {
                this.$changeOptionsEV("", "endTime", false, null, this.myid, true)
              } else {
                if (data && data[0]) {
                  this.$changeOptionsEV(data[0][Object.keys(data[0])[0]].value, "endTime", false, null, this.myid, true)
                }
              }
            } else if (
              this.options.currentFiledMapping &&
              this.options.currentFiledMapping.fieldFlag &&
              data.length > 0
            ) {
              if (data && data[0]) {
                const dataType = this.options.currentFiledMapping.dataType
                let data1 = data[0][this.options.currentFiledMapping.fieldFlag]
                if (this.options.getDataCount) {
                  //兼容获取数据数量的情况
                  data1 = data[0][0]
                }
                let tempDataValue = data1.value
                if (dataType === "dataKey") {
                  tempDataValue = data1.key + "：" + data1.value
                } else if (dataType === "dataName") {
                  tempDataValue = data1.key
                }
                this.$changeOptionsEV(tempDataValue, "endTime", false, null, this.myid, true)
              }
            } else if (data.length === 0) {
              this.$changeOptionsEV("", "endTime", false, null, this.myid, true)
            }
          }
        },
        1
      )
    },
    formatterTime(value, maxValue = 100) {
      if (value < 10) {
        return maxValue == 100 ? `0${value}` : `00${value}`
      } else if (value > 10 && value < 99) {
        return maxValue == 100 ? `${value}` : `0${value}`
      } else return `${value}`
    },
    clearCountDown() {
      this.timeData = {
        years: this.formatterTime(0),
        months: this.formatterTime(0),
        days: this.formatterTime(0),
        hours: this.formatterTime(0),
        minutes: this.formatterTime(0),
        seconds: this.formatterTime(0)
      }
    },
    startCountDown(value) {
      if (!dayjs(value).isValid()) {
        this.clearCountDown()
        return
      }
      value = new Date(value).getTime()
      this.countdown = new RAFCountdown(
        value,
        time => {
          this.timeData = {
            years: this.formatterTime(time.years),
            months: this.formatterTime(time.months),
            days: this.formatterTime(time.days),
            hours: this.formatterTime(time.hours),
            minutes: this.formatterTime(time.minutes),
            seconds: this.formatterTime(time.seconds)
          }
        },
        () => {
          this.clearCountDown()
          console.log("倒计时结束")
        },
        this?.mainConfig?.mainEnd?.value ?? "stop",
        this.filterUnits,
      )
      this.countdown.start()
    },
    // 停止倒计时
    // countdown.stop();

    handleEnd() {},
    changeShareType(id) {
      this.activeIndex = id
    },
    mouseenterEv(id) {
      this.hoverIndex = id
      if (id === 0 || id === 2) {
        this.$nextTick(() => {
          this.generateQrcode()
        })
      }
    },
    mouseleaveEv() {
      this.hoverIndex = -1
    }
  }
}
</script>
<style lang="scss" scoped>
.countdown-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  border-width: var(--mainBorder_borderWidth);
  border-color: var(--mainBorder_borderColor) !important;
  border-style: var(--mainBorder_borderStyle);
  background-repeat: var(--mainrBackground_backgroundRepeat);
  background-image: var(--mainBackground_backgroundImage);
  background-color: var(--mainBackground_backgroundColor);
  background-size: var(--mainBackground_backgroundSize);
  background-position: var(--mainBackground_backgroundPosition);
  border-radius: var(--mainRadius);
  opacity: var(--mainOpacity);
  box-shadow: var(--mainShadow);
  padding: var(--mainPadding);
}
.countdown-box {
  display: flex;
  width: 100%;
}
.count-item {
  display: flex;
}
.count-item-number {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  font-variant: tabular-nums;
  font-variant-numeric: tabular-nums;
  font-feature-settings: "tnum";
  border-width: var(--numberBorder_borderWidth);
  border-color: var(--numberBorder_borderColor) !important;
  border-style: var(--numberBorder_borderStyle);
  background-repeat: var(--numberBackground_backgroundRepeat);
  background-image: var(--numberBackground_backgroundImage);
  background-color: var(--numberBackground_backgroundColor);
  background-size: var(--numberBackground_backgroundSize);
  background-position: var(--numberBackground_backgroundPosition);
  border-radius: var(--numberRadius);
  opacity: var(--numberOpacity);
  box-shadow: var(--numberShadow);
  padding: var(--numberPadding);
}
.count-item-unit {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  opacity: var(--unitOpacity);
}
.count-item-box {
  display: flex;
  align-items: center;
}
</style>
